<template>
  <img
    v-if="brokerLogo"
    class="mx-auto my-8 hidden h-11 w-auto md:block"
    :src="brokerLogo"
    alt="broker logo"
  />
  <layout class="mt-6">
    <h1 class="header-text text-center">Sorry.</h1>
    <p class="mb-4 text-dark-gray">
      You’ve reached your daily limit for onboarding packets. For additional
      support, feel free to email us at
      <a
        href="mailto:service@highway.com"
        class="cursor-pointer text-yellow-500 underline"
      >
        service@highway.com
      </a>
    </p>
  </layout>
</template>

<script>
import { onMounted, ref } from 'vue';
import Layout from '@/components/layouts/HoldingTankLayout.vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  name: 'CarrierLimitExceeded',
  components: { Layout },
  setup() {
    const store = useStore();
    const router = useRouter();
    const brokerLogo = ref(null);
    const brokerName = ref('');

    onMounted(async () => {
      const publicDetails = await store.dispatch(
        'brokers/getLogoByClientId',
        localStorage.getItem('client_id')
      );
      if (publicDetails.status === 200) {
        brokerLogo.value = publicDetails?.data?.url;
        brokerName.value = publicDetails?.data?.legal_name;
      }
    });

    const navigate = () => {
      router.push('/carrier?updateEld=true&eldProviders=true');
    };

    return { brokerLogo, navigate, brokerName };
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}

.link-icon {
  position: relative;
  bottom: 1px;
}
</style>
